"use client";

import { c as _c } from "react/compiler-runtime";
import { breakpoints } from "../../constants/breakpoints";
import { createMedia } from "./createMedia";
const {
  Media: MediaBase,
  SizeProvider,
  MediaContextProvider,
  useSizeContextSelector,
  createMediaStyle
} = createMedia(breakpoints);
export const getBreakpointPixelValue = bp => {
  return breakpoints[bp];
};
const useLessThanBreakpointContextSelector = breakpoint => {
  const $ = _c(2);
  let t0;
  if ($[0] !== breakpoint) {
    t0 = value => !!value.width && value.width < breakpoints[breakpoint];
    $[0] = breakpoint;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSizeContextSelector(t0);
};
export const useIsLessThanSm = () => {
  return useLessThanBreakpointContextSelector("sm");
};
export const useIsLessThanMd = () => {
  return useLessThanBreakpointContextSelector("md");
};
export const useIsLessThanLg = () => {
  return useLessThanBreakpointContextSelector("lg");
};
export const useIsLessThanXl = () => {
  return useLessThanBreakpointContextSelector("xl");
};
export const useIsLessThan2Xl = () => {
  return useLessThanBreakpointContextSelector("2xl");
};
export const useIsLessThan3Xl = () => {
  return useLessThanBreakpointContextSelector("3xl");
};
export const useIsLessThan4Xl = () => {
  return useLessThanBreakpointContextSelector("4xl");
};
export const useIsLessThan5Xl = () => {
  return useLessThanBreakpointContextSelector("5xl");
};
export const useIsGreaterThanOrEqualToLg = () => {
  return !useIsLessThanLg();
};
export const useIsLessThanBreakpoint = breakpoint => {
  return useLessThanBreakpointContextSelector(breakpoint);
};

// Make styles for injection into the header of the page
export const mediaStyles = createMediaStyle();
function Media(t0) {
  const $ = _c(6);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== rest) {
    t1 = <MediaBase className="contents" {...rest}>{children}</MediaBase>;
    $[3] = children;
    $[4] = rest;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
/**
 * Recommendation: Avoid rendering multiple children within a Fragment as the
 * child of a Media component
 *
 * Issues with the incorrect classnames being applied to elements may arise
 */
export { Media, MediaContextProvider, SizeProvider };